import Swal from 'sweetalert2/dist/sweetalert2.js'

const SwallCostum = {
    ConfrimDelete: (callback) =>
        Swal.fire({
            title: 'Apakah Anda Ingin Menghapus Data Ini?',
            text: 'Data akan di hapus secara permanent!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya!',
            cancelButtonText: 'Tidak'
        }).then((result) => {
            if (result.value) {
                callback();
                Swal.fire(
                    'Hapus Data Berhasil !',
                    'Data Anda Telah DiHapus.',
                    'success'
                )
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire(
                    'Hapus Data Di tangguhkan',
                    'Data Anda Sekarang Aman :)',
                    'error'
                )
            }
        }),
    ConfrimUpdateSucess: (callback) =>
        Swal.fire({
            title: 'Update Data Berhasil',
            text: 'Data Anda Sekarang Sudah Di Update',
            type: 'success',

            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimAddSucess: (callback) =>
        Swal.fire({
            title: 'Tambah Data Berhasil',
            text: 'Data Anda Sudah Di Tambahkan',
            type: 'success',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimDeleteSucess: (callback) =>
        Swal.fire({
            title: 'Hapus Data Berhasil',
            text: 'Data Anda Sudah Di Hapus',
            type: 'success',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),

    ConfrimFailUpload: (callback) =>
        Swal.fire({
            title: 'Gagal Unggah Data',
            text: 'Pastikan File Yang Anda Upload Kurang dari 2 MB ',
            type: 'warning',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimFailedDelete: (callback) =>
        Swal.fire({
            title: 'Hapus Data Gagal',
            text: 'Pastikan Inputan Anda Benar',
            type: 'warning',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimFailedUpdate: (callback) =>
        Swal.fire({
            title: 'Update Data Gagal',
            text: 'Pastikan Inputan Anda Benar',
            type: 'warning',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimFailedAdd: (callback) =>
        Swal.fire({
            title: 'Tambah Data Gagal',
            text: 'Pastikan Inputan Anda Benar',
            type: 'warning',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimSuccessCostum: (title, message, callback) =>
        Swal.fire({
            title: title,
            text: message,
            type: 'success',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimSwitchCustom: (message, callback) =>
        Swal.fire({
            title: 'Ubah Status Berhasil',
            text: message,
            type: 'success',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimResetPasswordCustomError: (message, callback) =>
        Swal.fire({
            title: 'Gagal Ubah Password',
            text: message,
            type: 'warning',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimFailedCostum: (title, message, callback) =>
        Swal.fire({
            title: title,
            text: message,
            type: 'warning',
            confirmButtonText: 'Oke',
        }).then((result) => {
            if (result.value) {
                callback();
            }
        }),
    ConfrimDeleteCostumMsg: (msg,callback) =>
        Swal.fire({
            title: 'Apakah Anda Ingin Menghapus Data Ini?',
            text: msg,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya!',
            cancelButtonText: 'Tidak'
        }).then((result) => {
            if (result.value) {
                callback();
                
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire(
                    'Hapus Data Di tangguhkan',
                    'Data Anda Sekarang Aman :)',
                    'error'
                )
            }
        }),




}
export default SwallCostum